import React from 'react';
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

export default function SupervisorSelector({
	triggerClassName = '',
	triggerInnerClassName = '',
	triggerText = 'Add a Supervisor',
	isEmpty = false,
	useDefaultLinkColors = true,
	onOpen = () => {},
	isOpen = false,
	optionsRef = null,
	supervisors = [],
	onAddSupervisor = () => {},
	onClose = () => {},
	settingsPath = '/app/hsms/settings/users',
	redirectPath = '/app/hsms/progress/section_creation/create_sections',
}) {
	return (
		<>
			<div className={`${triggerClassName} ${useDefaultLinkColors ? (isEmpty ? 'blue-link' : 'gray-to-blue-link') : ''}`} onClick={onOpen}>
				{triggerInnerClassName ? <div className={triggerInnerClassName}>{triggerText}</div> : triggerText}
			</div>
			<div className='supervisor-options-container'>
				{isOpen &&
					<div className='data-options-container' ref={optionsRef}>
						{supervisors.map((supervisor_info, index) => {
							return (
								<div className='data-options-option assign-resourses-supervisor-option' key={index} onClick={() => onAddSupervisor(supervisor_info)}>
									{supervisor_info.img_url &&
										<img className='department-supervisor-img' src={require(`../../../../images/users/${supervisor_info.img_url}`)} alt='supervisor' />
									}
									{!supervisor_info.img_url &&
										<FontAwesomeIcon className='department-supervisor-user-icon' icon={faUserCircle}/>
									}
									<div className='department-supervisor-name'>{supervisor_info.last_name}, {supervisor_info.first_name}</div>
								</div>
							)
						})}
						<Link className='data-options-option blue-text' to={{pathname: settingsPath, redirect: redirectPath}} style={{borderTop:'1px solid #efefef'}} onClick={onClose}>Add new Supervisor</Link>
					</div>
				}
			</div>
		</>
	);
}
